import React from 'react';

import {
    CompareArrowsRounded as AlteracaoEmpresaIcon,
    Home as HomeIcon,
    MonetizationOnRounded as FaturaIcon,
    DriveEta as MeusCarrosIcon,
    BuildRounded as ServicosIcon,
    ExitToApp as LogoutIcon,
    ContactlessRounded as CarroConectadoIcon,
    HelpOutlined as ContatosIcon
} from '@material-ui/icons';

import { MenuEnum } from '../enums';

function IconeMenu(
    {
        menu,
        ...props
    }
) {
    const icone = {
        [MenuEnum.SELECAO_EMPRESA]: <AlteracaoEmpresaIcon {...props} />,
        [MenuEnum.HOME]: <HomeIcon {...props} />,
        [MenuEnum.FATURAS]: <FaturaIcon {...props} />,
        [MenuEnum.MEUS_CARROS]: <MeusCarrosIcon {...props} />,
        [MenuEnum.SERVICOS]: <ServicosIcon {...props} />,
        [MenuEnum.CARRO_CONECTADO]: <CarroConectadoIcon {...props} />,
        [MenuEnum.CONTATOS]: <ContatosIcon {...props} />,
        [MenuEnum.LOGOUT]: <LogoutIcon {...props} />
    }

    return (icone[menu]);
}

export default IconeMenu;